export enum Routes {
    HOME = "/platform/:platform",
    GADGET_DETAILS = "/gadgets/:id",
    ABOUT_PLATFORM = "/about-platform",
    ABOUT_RECIPE = "/about-recipe",
    ABOUT_GADGET_BUILDER = "/about-agent-builder",
    USER_REGISTRATION_STATUS ="/user-registration-status",
    KNOWLEDGE_BASE="knowledge-base",
    CHANGELOG="change-log",
    CASE_STUDIES_SHIMADZU="case-studies-shimadzu",
    CASE_STUDIES_PRISM="case-studies-prism",
    DOWNLOADS="downloads",
    HELP_SUPPORT="help-support"
}